import { createContext, Dispatch, useContext } from "react";
import { Graph_QL } from "../../../Services";
import { RenameLocation, RenameSection, RenameStation, UpdateTerminal } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/createLfSectionCall";

export enum ITerminalResContextEnum {
  sectionNames = "sectionNames",
  penNames = "penNames",
  stationNames = "stationNames",
  terminalValues = "terminalValues",
  updatedLocations = "updatedLocations"
}

export type ITerminalResContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  
  sectionNames?: Record<number, RenameSection>;
  penNames?: Record<number, RenameLocation>;
  stationNames?: Record<number, RenameStation>;
  terminalValues?: Record<number, UpdateTerminal>;

  updatedLocations?: Record<number, boolean>;
}

export type TerminalResDispatcherT = Deep_Partial<ITerminalResContext>;

type TerminalResContexter = {
  state: ITerminalResContext,
  dispatch: Dispatch<TerminalResDispatcherT>
}

export const TerminalResContext = createContext<TerminalResContexter | undefined>(undefined);

export function TerminalResReducer(state: ITerminalResContext, action: TerminalResDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case ITerminalResContextEnum.sectionNames: {
        const updates = payload as RenameSection[];
      
        const existing = ResultState.sectionNames ?? {};
      
        const merged = { ...existing };
      
        updates.forEach(update => {
          merged[update.section_id] = {
            ...merged[update.section_id],
            ...update
          };
        });
      
        ResultState = {
          ...ResultState,
          sectionNames: merged
        };
        break;
      }
      case ITerminalResContextEnum.penNames: {
        const updates = payload as RenameLocation[];
      
        const existing = ResultState.penNames ?? {};
      
        const merged = { ...existing };
      
        updates.forEach(update => {
          merged[update.location_id] = {
            ...merged[update.location_id],
            ...update
          };
        });
      
        ResultState = {
          ...ResultState,
          penNames: merged
        };
        break;
      }
      case ITerminalResContextEnum.stationNames: {
        const updates = payload as RenameStation[];
      
        const existing = ResultState.stationNames ?? {};
      
        const merged = { ...existing };
      
        updates.forEach(update => {
          merged[update.station_id] = {
            ...merged[update.station_id],
            ...update
          };
        });
      
        ResultState = {
          ...ResultState,
          stationNames: merged
        };
        break;
      }
      case ITerminalResContextEnum.terminalValues: {
        const updates = payload as UpdateTerminal[];
      
        const existing = ResultState.terminalValues ?? {};
      
        const merged = { ...existing };
      
        updates.forEach(update => {
          merged[update.terminal_id] = {
            ...merged[update.terminal_id],
            ...update
          };
        });
      
        ResultState = {
          ...ResultState,
          terminalValues: merged
        };
        break;
      }
      case ITerminalResContextEnum.updatedLocations: {
        const updates = payload as Record<number, boolean>;
      
        ResultState = {
          ...ResultState,
          updatedLocations: {
            ...(ResultState.updatedLocations ?? {}),
            ...updates
          }
        };
        break;
      }
      default:
        console.error(`Unhandled action type: ${type}`);
      break;
    }
  })
  return ResultState;
}

export const useTerminalResContext = () => {
  const context = useContext(TerminalResContext);
  if (!context) {
    throw new Error("useTerminalResContext must be used within a ModalProvider");
  }
  return context;
};